<template>
  <li
    class="nav-item dropdown hover-pointer"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <!-- desktop toggler -->
    <a
      class="
        text-white
        nav-link
        dropdown-toggle
        cursor-pointer
        d-none d-lg-block
      "
    >
      {{ title }}
    </a>
    <!-- mobile toggler -->
    <a
      class="
        text-white
        nav-link
        dropdown-toggle
        cursor-pointer
        d-lg-none d-block
      "
    >
      {{ title }}
    </a>
    <!-- desktop dropdown -->
    <transition name="fade">
      <ul
        v-show="hover"
        :class="hover ? 'd-lg-block' : null"
        class="dropdown-menu dropdown-menu-end d-none"
        @mouseover="hover = true"
        @mouseleave="hover = false"
      >
        <li
          v-for="[nestedLink, link, key] in content"
          :key="key"
          class="nav-item"
        >
          <a class="nav-link" :href="buildLink(link)">{{ nestedLink }}</a>
        </li>
      </ul>
    </transition>
    <!-- mobile dropdown -->
    <ul class="d-lg-none d-block">
      <li
        v-for="[nestedLink, link, key] in content"
        :key="key"
        class="nav-item"
      >
        <a class="nav-link text-white" :href="buildLink(link)">{{
          nestedLink
        }}</a>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  props: {
    content: {
      type: Map,
      default: () => new Map(),
      required: true,
    },
    baseUri: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      hover: false,
    }
  },
  computed: {},
  methods: {
    buildLink(link) {
      return this.baseUri + link
    },
  },
}
</script>

<style scoped lang="scss">
a.dropdown-toggle {
  position: relative;
  white-space: nowrap;
  font-size: 1rem;
  font-weight: 600;
  position: relative;
  text-decoration: none;
  transition: color 0.4s ease-in-out;
  border-bottom: 2px solid transparent;
  &:hover {
    text-decoration: none;
    color: var(--bs-ternary) !important;
    filter: opacity(0.7);
    font-weight: 700;
  }
}
.dropdown-menu {
  -webkit-transform: translate3d(0, 0, 0);
  transition: all 0.2s ease-in-out;
  position: absolute;
  z-index: 1000;
  display: unset;
  min-width: 10rem;
  padding: 20px 0;
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--bs-white);
  text-align: left;
  list-style: none;
  background-color: var(--bs-primary);
  background-clip: padding-box;
  border-radius: 0;
  border-top: var(--bs-ternary) solid 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  width: 240px;
  position: absolute;
  top: 4.7em;
  overflow-wrap: break-word;
  text-decoration: none;
  transition: color 0.4s ease-in-out;
  &:hover {
    text-decoration: none;
    color: var(--bs-ternary);
  }
  li {
    word-wrap: break-word;
    display: inline-block;
    margin: 0;
    padding: 0 20px;
    line-height: 2em;
    a.nav-link {
      width: 200px;
      font-weight: 600;
      line-height: 1.2;
      padding: 0.5rem 0;
      color: var(--bs-white);
      word-wrap: break-word;
      white-space: pre-wrap;
      font-weight: 600;
      font-size: 14px;
      display: block;
      position: relative;
      text-decoration: none;
      transition: color 0.4s ease-in-out;
      &:hover {
        color: var(--bs-ternary);
      }
    }
  }
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: middle;
  content: '>';
  transform: rotate(90deg) scaleY(1.3);
  font-weight: 300;
  border: unset;
}
</style>
